export default {
    en: {
        select: 'Select',
        noScheduleName: "Please input the schedule's name",
        noValidityPeriod: 'Please input the period of validity',
        paramError: 'Input Error, Please Check Input Parameters',
        holidayName: 'Holiday Name',
        time: 'Time',
        happenYearly: 'Happen Yearly',
        addholiday: 'Add an Item',
        yes: 'Yes',
        no: 'No',
        finish: 'Finish',
        holidayError: 'Only one day or one period can be selected',
        libraryName: 'Library Name',
        libraryType: 'Library Type',
        verificationMethod: 'Verification method',
        faceSwiping: 'Face Swiping',
        faceSwipingCardSwiping: 'Face Swiping + Card Swiping',
        faceSwipingOrCardSwiping: 'Face Swiping or Card Swiping',
        validityPeriod: 'Period Of Validity',
        unlimitedDuration: 'Unlimited Duration',
        sundayPeriod: 'Sun',
        mondayPeriod: 'Mon',
        tuesdayPeriod: 'Tue',
        wednesdayPeriod: 'Wed',
        thursdayPeriod: 'Thur',
        fridayPeriod: 'Fri',
        saturdayPeriod: 'Sat',
        holidayPeriod: 'Holiday',
        noVerificationMethod: 'Please select verification method',
        BLACKLIST: 'Black Library',
        STAFF: 'Staff Library',
        GUEST: 'Guest Library',
        action: 'Action',
        timeRepeated: 'Holiday time cannot be repeated',
    },
    zh: {
        BLACKLIST: '黑名单库',
        STAFF: '员工库',
        GUEST: '访客库',
        noVerificationMethod: '请选择核验方式',
        scheduleName: '时刻表名称',
        validityPeriod: '访问有效期',
        unlimitedDuration: '无限期',
        sundayPeriod: '周日',
        mondayPeriod: '周一',
        tuesdayPeriod: '周二',
        wednesdayPeriod: '周三',
        thursdayPeriod: '周四',
        fridayPeriod: '周五',
        saturdayPeriod: '周六',
        holidayPeriod: '节假日',
        select: '请选择',
        faceSwiping: '刷脸',
        faceSwipingCardSwiping: '刷脸+刷卡',
        faceSwipingOrCardSwiping: '刷脸or刷卡',
        verificationMethod: '核验方式',
        libraryType: '库类型',
        libraryName: '库名称',
        noScheduleName: '请输入时刻表名称',
        noValidityPeriod: '请输入访问有效期',
        paramError: '输入错误, 请检查输入参数',
        holidayName: '节假日名称',
        time: '时间',
        happenYearly: '每年发生',
        addholiday: '添加一条',
        yes: '是',
        no: '否',
        finish: '完成',
        holidayError: '只能选择一天或一段日期',
        action: '操作',
        timeRepeated: '节假日时间不能重复',
    },
};
